import {StyleBuilder, TableConfig} from 'ngx-aur-mat-table';

import {DriverView} from '@common-module/modelinterfaces/driver-view.model';
import {TableConfigBuilder} from '@common-module/table-config/table-config.builder';

export const DELETE_DRIVER_ACTION = 'delete';
export const OPEN_DRIVER_HISTORY_ACTION = 'open-history';

export function createDriverListTableConfig(
  translate: (key: string) => string,
  isListMode: boolean,
  canEdit: boolean,
): TableConfig<DriverView> {
  return {
    trackBy: driver => driver.id,
    columnsCfg: [
      {
        key: 'avatar',
        name: '',
        valueConverter: () => '',
        valueView: {
          image: {
            src: row => row.rowSrc.avatarUrl,
            width: '30px',
            height: '30px',
          },
        },
        align: 'center',
        size: {
          fit: true,
        },
      },
      {
        ...TableConfigBuilder.column.value(
          'name',
          translate('term.name'),
          driver => driver.getFullName(),
        ),
        sort: TableConfigBuilder.column.sort.by(
          row => row.rowSrc.getFullName(),
        ),
      },
      {
        ...TableConfigBuilder.column.value(
          'phone',
          translate('unit.phone-number'),
          driver => driver.phoneNumber,
        ),
        sort: TableConfigBuilder.column.sort.enabled(),
      },
      {
        ...TableConfigBuilder.column.value(
          'unit',
          translate('term.unit'),
          driver => driver.unit?.name ?? '',
        ),
        valueView: {
          icon: {
            name: row => row.rowSrc.unit ? 'insert_link' : 'link_off',
          },
        },
        sort: TableConfigBuilder.column.sort.by(
          row => row.rowSrc.unit?.name ?? '',
        ),
      },
    ],
    actionCfg: isListMode
      ? {
          actions: [
            {
              action: () => OPEN_DRIVER_HISTORY_ACTION,
              icon: {
                name: () => 'history',
                color: () => 'var(--color-primary)',
              },
            },
            TableConfigBuilder.action.delete<DriverView>(
              DELETE_DRIVER_ACTION,
              () => translate('action.delete'),
              () => canEdit,
            ),
          ],
          size: TableConfigBuilder.action.size.compact(),
        }
      : undefined,
    stickyCfg: TableConfigBuilder.sticky.header(),
    extendedRowCfg: {
      mode: 'manual',
    },
    bodyRowCfg: {
      clickCfg: canEdit
        ? isListMode
          ? TableConfigBuilder.row.click.enabled()
          : TableConfigBuilder.row.click.enabled()
        : undefined,
      highlightCfg: canEdit && !isListMode
        ? {
            mode: 'controlled',
            styleCfg: {
              style: StyleBuilder.Row.builder().color('var(--color-primary)'),
            },
            cancelable: true,
          }
        : undefined,
      hoverCfg: canEdit
        ? TableConfigBuilder.row.hover.highlightedPointer('var(--color-divider)')
        : TableConfigBuilder.row.hover.disabled(),
    },
  };
}
